export default "__VITE_ASSET__e1f690ff__"